<template>
  <van-dialog
    v-model="innerVisible"
    :show-confirm-button="false"
    :show-cancel-button="false"
    :close-on-click-overlay="closeOnClickOverlay"
    v-bind="$attrs"
  >
    <div class="head">
      <img class="head-img" :src="icon" />
    </div>

    <div class="title">
      {{ computedTitle }}
    </div>

    <slot name="content"></slot>

    <!-- 双按钮模式 -->
    <div v-if="showBothButtons" class="footer-both">
      <van-button class="cancel" @click="handleCancel">
        {{ cancelText }}
      </van-button>
      <van-button class="confirm" @click="handleConfirm">
        {{ confirmText }}
      </van-button>
    </div>

    <!-- 仅确认按钮模式 -->
    <div v-else-if="showConfirmBtn" class="footer-single">
      <van-button class="confirm" @click="handleConfirm">
        {{ confirmText }}
      </van-button>
    </div>

    <!-- 仅取消按钮模式 -->
    <div v-else-if="showCancelBtn" class="footer-single">
      <van-button class="cancel" @click="handleCancel">
        {{ cancelText }}
      </van-button>
    </div>
  </van-dialog>
</template>

<script>
export default {
  name: 'CustomDialog',

  // 禁用默认的属性继承到根元素
  inheritAttrs: false,

  props: {
    // 控制弹窗显示
    visible: {
      type: Boolean,
      default: false
    },
    // 是否显示确认按钮
    showConfirmBtn: {
      type: Boolean,
      default: true
    },
    // 是否显示取消按钮
    showCancelBtn: {
      type: Boolean,
      default: true
    },
    // 确认按钮文字
    confirmText: {
      type: String,
      default: '确认'
    },
    // 取消按钮文字
    cancelText: {
      type: String,
      default: '取消'
    },
    // 确认按钮颜色
    confirmColor: {
      type: String,
      default: '#1989fa'
    },
    // 取消按钮颜色
    cancelColor: {
      type: String,
      default: '#333'
    },
    // 是否点击遮罩关闭
    closeOnClickOverlay: {
      type: Boolean,
      default: false
    },
    // 图标
    icon: {
      default: require('@/assets/images/icon-tips.png'),
      type: [String, Object]
    },
    // 标题（从 $attrs 中获取或使用 prop）
    title: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      innerVisible: this.visible
    };
  },

  computed: {
    // 是否显示两个按钮
    showBothButtons() {
      return this.showConfirmBtn && this.showCancelBtn;
    },

    // 从 $attrs 获取标题，优先使用 props 的 title
    computedTitle() {
      return this.title || this.$attrs.title || this.$attrs.name || '';
    }
  },

  watch: {
    // 监听外部 visible 变化
    visible(val) {
      this.innerVisible = val;
    },
    // 监听内部 visible 变化并通知父组件
    innerVisible(val) {
      this.$emit('update:visible', val);
    }
  },

  methods: {
    // 确认按钮点击
    handleConfirm() {
      this.$emit('confirm');
    },

    // 取消按钮点击
    handleCancel() {
      this.$emit('cancel');
    },

    // 弹窗关闭后
    handleClosed() {
      this.$emit('closed');
    },

    // 打开弹窗（可以通过 ref 调用）
    open() {
      this.innerVisible = true;
    },

    // 关闭弹窗（可以通过 ref 调用）
    close() {
      this.innerVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .van-dialog__content {
  box-sizing: border-box;
  border-radius: 8px;
  opacity: 1;
  border: 1.5px solid #ffffff;
  background: linear-gradient(180deg, #ffd9db 0%, #ffffff 26%);
  padding: 0 20px 20px;
  overflow: hidden;
}

.head {
  text-align: center;
  height: 60px;
  margin-top: 20px;

  .head-img {
    width: 60px;
    height: 60px;
  }
}

.title {
  color: #333333;
  font-size: 20px;
  font-weight: 700;
  font-family: 'PingFang SC';
  text-align: center;
  margin-top: 10px;
  margin-bottom: 20px;
}

// 双按钮布局
.footer-both {
  display: flex;
  justify-content: space-between;
  gap: 10px;

  .cancel,
  .confirm {
    flex: 1;
    height: 44px;
    border-radius: 22px;
    font-size: 16px;
    font-weight: 700;
    font-family: 'PingFang SC';
    border: none;
  }

  .cancel {
    background: #ffffff;
    color: #fa5050;
    font-size: 16px;
    font-weight: 500;
    font-family: 'PingFang SC';
    border: 0.5px solid #fa5050;
    &:active {
      background: #e8e8e8;
    }
  }

  .confirm {
    border-radius: 19.5px;
    opacity: 1;
    background-color: #feeded;
    color: #fa5050;
    font-size: 16px;
    font-weight: 500;
    font-family: 'PingFang SC';
    &:active {
      opacity: 0.9;
    }
  }
}

// 单按钮布局
.footer-single {
  .cancel,
  .confirm {
    width: 100%;
    height: 44px;
    border-radius: 22px;
    font-size: 16px;
    font-weight: 700;
    font-family: 'PingFang SC';
    border: none;
  }

  .cancel {
    background: #f5f5f5;
    color: #333;

    &:active {
      background: #e8e8e8;
    }
  }

  .confirm {
    background: #1989fa;
    color: #fff;

    &:active {
      opacity: 0.9;
    }
  }
}
</style>
